import { useTRPCAPI, useTRPCQuery } from '../../../trpc/trpc';
import { useShareTokenInput } from './useShareTokenInput';
import { useSMLCountryParam } from './useSMLCountryParam';
import { useSMLGenreParam } from './useSMLGenreParam';

interface UseTracksTopGainingProps {
  page: number;
  date?: Date;
  limit?: number;
  artistId?: string;
}

export const useTracksTopGaining = ({ page, limit = 10, date, artistId }: UseTracksTopGainingProps) => {
  const trpcMusicAPI = useTRPCAPI();
  const shareTokenInput = useShareTokenInput();
  const { countryCode } = useSMLCountryParam();
  const { genre } = useSMLGenreParam();
  const offset = (page - 1) * limit;

  const tracksQuery = useTRPCQuery(
    trpcMusicAPI.tracks.topGaining.queryOptions({
      offset,
      limit,
      date: date ?? undefined,
      artistId,
      countryCode,
      genre,
      ...shareTokenInput,
    })
  );

  return tracksQuery;
};
